/**
 * Announces that the visitor has just accepted, for GTM triggers to match.
 *
 * Add it as a Custom Event trigger on any tag that should fire on acceptance
 * rather than waiting for the next page load. Inert until something in the
 * container listens for it.
 */
export const CONSENT_GRANTED_EVENT = 'consent_granted';

export const gtmPlugin = (store) => {
  if (typeof window === 'undefined') return; // SSR guard if needed

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }

  // When the app boots, update consent from your stored state.
  // Advanced consent mode: the container is already on the page with everything
  // denied (see public/index.html), so this only has to flip the state.
  const currentConsent = store.getters['consent/consentData'];
  gtag('consent', 'update', currentConsent);

  // Listen for consent changes
  store.subscribe((mutation) => {
    if (mutation.type === 'consent/setHasConsent' || mutation.type === 'consent/setConsentData') {
      const consent = store.getters['consent/consentData'];
      gtag('consent', 'update', consent);

      /*
       * Triggers match events, not consent state, so the update above
       * re-evaluates nothing on its own: every tag blocked when the container
       * loaded stays blocked until the next page load, which is why accepting
       * can look like it did nothing until you refresh. This gives those tags
       * something to match in the same page view; their own consent checks
       * still decide whether they may fire.
       *
       * After the update, never before - pushed first it would wake the
       * triggers while consent still read denied and they would block exactly
       * as before, looking correct while achieving nothing.
       */
      if (consent.ad_storage === 'granted') {
        window.dataLayer.push({ event: CONSENT_GRANTED_EVENT });
      }

      // tolt.js is held back until consent is given (see public/index.html), so
      // load it here rather than leaving it until the next page load.
      if (consent.ad_storage === 'granted' && typeof window.loadToltScript === 'function') {
        window.loadToltScript();
      }
    }
  });
};
